'use client';

import BackArrowIcon from './BackArrowIcon/index.js';
import NextArrowIcon from './NextArrowIcon/index.js';
import SearchIcon from './SearchIcon/index.js';

var GlyphIcons = {
    BackArrowIcon: BackArrowIcon,
    NextArrowIcon: NextArrowIcon,
    SearchIcon: SearchIcon
};

export { GlyphIcons as default };
//# sourceMappingURL=index.js.map
